import React from 'react';
import PageTitle from '../../layouts/PageTitle';
import '../../../scss/pages/_report-list.scss'
import { useHistory } from 'react-router-dom';

const ReportList = () => {

    const history = useHistory();


    return (
        <div className='report'>
            <PageTitle
                title="Reports"
                subtitle="Reports"
            />

            <div className="row note">
                <small>Disclimer. Please note that the reports present raw and unconditioned order data. Revenue includes only food values (excluding discounts, delivery fees, etc). Final sattelment can be found frrom the invoices.</small>
            </div>

            <div onClick={() => history.push("/list/day/report")} className="card-header report-list mt-3">
                <div className="row w-100 align-items-center">
                    <div className="col-md-10 col-lg-10 d-flex justify-content-start">
                        <div className="lefticon d-flex justify-content-center align-items-center">
                            <i className="mdi mdi-currency-usd"></i>
                            <ul className='ms-5'>
                                <li className='fw-bold'>End of day report</li>
                                <li>Summery of the day</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2 righticon">
                        <i className="mdi mdi-chevron-right mdi-24px float-end"></i>
                    </div>
                </div>
            </div>

            <div onClick={() => history.push("/list/performance/report")} className="card-header report-list">
                <div className="row w-100 align-items-center">
                    <div className="col-md-10 col-lg-10 d-flex justify-content-start">
                        <div className="lefticon d-flex justify-content-center align-items-center">
                            <i className="mdi mdi-chart-line-variant"></i>
                            <ul className='ms-5'>
                                <li className='fw-bold'>Performance Report</li>
                                <li>Orders and revenue will share option</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2 righticon">
                        <i className="mdi mdi-chevron-right mdi-24px float-end"></i>
                    </div>
                </div>
            </div>

            <div onClick={() => history.push("/list/orderdetails/report")} className="card-header report-list">
                <div className="row w-100 align-items-center">
                    <div className="col-md-10 col-lg-10 d-flex justify-content-start">
                        <div className="lefticon d-flex justify-content-center align-items-center">
                            <i className="bi bi-list-ul"></i>
                            <ul className='ms-5'>
                                <li className='fw-bold'>Order Details</li>
                                <li>Order history with detailed data</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2 righticon">
                        <i className="mdi mdi-chevron-right mdi-24px float-end"></i>
                    </div>
                </div>
            </div>

            <div onClick={() => history.push("list/revenuebyhour/report")} className="card-header report-list">
                <div className="row w-100 align-items-center">
                    <div className="col-md-10 col-lg-10 d-flex justify-content-start">
                        <div className="lefticon d-flex justify-content-center align-items-center">
                            <i className="bi bi-alarm"></i>
                            <ul className='ms-5'>
                                <li className='fw-bold'>Revenue by hour</li>
                                <li>Revenue and orders by weekday and hour </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2 righticon">
                        <i className="mdi mdi-chevron-right mdi-24px float-end"></i>
                    </div>
                </div>
            </div>

            <div onClick={() => history.push("list/menueitem/report")} className="card-header report-list">
                <div className="row w-100 align-items-center">
                    <div className="col-md-10 col-lg-10 d-flex justify-content-start">
                        <div className="lefticon d-flex justify-content-center align-items-center">
                            <i className="mdi mdi-silverware-variant mdi-18px"></i>
                            <ul className='ms-5'>
                                <li className='fw-bold'>Menu performance</li>
                                <li>Menu items by popularity </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2 righticon">
                        <i className="mdi mdi-chevron-right mdi-24px float-end"></i>
                    </div>
                </div>
            </div>

            <div onClick={() => history.push("/list/topzip/report")} className="card-header report-list">
                <div className="row w-100 align-items-center">
                    <div className="col-md-10 col-lg-10 d-flex justify-content-start">
                        <div className="lefticon d-flex justify-content-center align-items-center">
                            <i className="mdi mdi-map-marker"></i>
                            <ul className='ms-5'>
                                <li className='fw-bold'>Top ZIP</li>
                                <li>Zip code performance</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-2 righticon">
                        <i className="mdi mdi-chevron-right mdi-24px float-end"></i>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ReportList;